import * as d3 from 'd3-selection'
import labels from './labels'

const rads = degrees => {
  return degrees * (Math.PI / 180)
}

const projectPoint = (angle, distance) => {
  angle = rads(angle)
  let x = (Math.cos(angle) * distance)
    , y = (Math.sin(angle) * distance)

  return [x, y]
}

const angledWidth = height => {
  return (height * Math.sin(rads(30))) / Math.sin(rads(75))
}

const drawing = selection => {
  selection.each(function (d, i, all) {
    let path = d3.select(this).selectAll('path')
      .data(d => d.paths)

    path.exit().remove()

    path.enter()
        .append('path')
        .merge(path)
        .attr('d', d => {
          let p = `M ${d.coords[0]}`
          p += d.coords.slice(1).map(coord => ` L ${coord}`).join(' ')
          p += 'Z'
          return p
        })
        .attr('fill', d => `url(#${d.fill})`)

  })
}

const stageData = (chartId, point, i, all, pyramid) => {
  let dimensions = pyramid.dimensions
    , above = all[i + 1] // stage above the current
    , next = !!above ? above : {height: 0, width: 0, offset: -dimensions.padding}
    , bottom = projectPoint(-15, angledWidth(point.height + point.offset))
    , top = projectPoint(-15, angledWidth(next.height + next.offset + dimensions.padding))
    , paths = []

  // Left path. Must be first, since the label code looks at these coords
  paths.push({
    fill: !!above ? `${chartId}-pyramid-left-${point.color}` : `${chartId}-pyramid-top-left-${point.color}`,
    coords: [
      [dimensions.center, point.height],
      [dimensions.center - bottom[0], point.height + bottom[1]],
      [dimensions.center - top[0], next.height + top[1]],
      [dimensions.center, next.height]
    ]
  })

  // Right path
  paths.push({
    fill: !!above ? `${chartId}-pyramid-right-${point.color}` : `${chartId}-pyramid-top-right-${point.color}`,
    coords: [
      [dimensions.center, point.height],
      [dimensions.center + bottom[0], point.height + bottom[1]],
      [dimensions.center + top[0], next.height + top[1]],
      [dimensions.center, next.height]
    ]
  })

  // All pieces except for the top have a 3rd shape above the left/right paths
  if (!!above) {
    let delta = next.height - (next.height + top[1])
    paths.push({
      fill: `${chartId}-pyramid-lid-${point.color}`,
      coords: [
        [dimensions.center, next.height],
        [dimensions.center + top[0], next.height + top[1]],
        [dimensions.center, next.height - delta * 2],
        [dimensions.center - top[0], next.height + top[1]]
      ]
    })
  }

  return Object.assign({}, point, {
    stage: point.idx + 1,
    _point: point,
    _range: pyramid.block.range,
    paths
  })
}

export default (selection, chart, pyramids, config) => {
  selection.each(function () {
    let container = d3.select(this)
                      .selectAll('g.pyramid-container')
                      .data(pyramids.map(pyramid => {
                        return Object.assign({}, pyramid, {
                          _stages: pyramid.points.map((point, i, all) => {
                            return stageData(chart.id, point, i, all, pyramid)
                          })
                        })
                      }))
    container.exit().remove()
    container = container.enter()
                         .append('g')
                         .attr('class', 'pyramid-container')
                         .merge(d3.select(this).selectAll('.pyramid-container'))

    let group = container.selectAll('g.stage')
                         .data(d => d._stages)

    group.exit().remove()

    group = group.enter()
                 .append('g')
                 .attr('class', d => `stage is-deemphasizable ${d.color}`)
                 .on('click', (e, d) => {
                   if (d.clickable) {
                     chart.ee.emit('chart-event', 'select:point', d._point, d._range)
                   }
                  })
                 .merge(group)
                 .classed('deemphasize', d => d.deemphasize)
                 .classed('is-clickable', d => d.clickable)

    group.attr('transform', d => `translate(0, ${d.offset})`)
         .call(drawing)

    // Add the labels. We can't nest them inside of the stage because of z-indexing
    container.call(labels, config)
             .attr('transform', function (d) {
               let shapeHeight = this.getBBox().height
                 , blockHeight = d.block.dimensions.height
                 , offset = (blockHeight - shapeHeight) / 2

               return `translate(${d.block.dimensions.x}, ${d.block.dimensions.y + offset})`
             })
  })
}

